import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    root: { 
        padding: '1.5rem 3rem 0 3rem'
    },

    formBody: {
        paddingTop: '2rem'
    },
    rootWrapper:{
        width: '100%',
        height: '100%'
    }
}));

export default useStyles;